import { money } from "../../utilities/currency";

/** Svenska (Swedish) */
const sv = {
  home: {
    offer: "✨ Specialerbjudande – Betala 99 kr, få 198 kr i samtalskredit! ✨",
    signIn: "Logga in",
    join: "Gå med",
    allAdvisors: "Alla rådgivare",
    festivalTitle: "Festivalkampanjer",
    referTitle: "Få din första konsultation gratis!",
    referBody:
      "Boka ett 15-minuters gratissamtal. Perfekt för att hitta rätt rådgivare – tryggt, digitalt och utan förpliktelser.",
    blogTitle: "Från Mystic-bloggen",
    viewAll: "Se alla",
    subscribeLine: "Få nya guider och erbjudanden via e-post.",
    read: "Läs",
    invite: "Boka gratis konsultation",
    sponsored: "Sponsrad",
    ad: (n) => `Annons ${n}`,
    adBlurb: "Annonsera produkter, appar eller evenemang här.",
    learnMore: "Läs mer",
    connectNow: "Anslut nu",
    from: "från",
    minutes: "min",
    verified: "Verifierad",
    categories: [
      "Kärleksreading",
      "Klärvoajant reading",
      "Tarot-reading",
      "Astrologi & Horoskop",
      "Änglabudskap",
      "Orakel-vägledning",
      "Drömtydning",
      "Andligt medium",
    ],
    hero: {
      name: "Rådgivarna",
      tag: "Kärleksexpert",
      blurb:
        "Mitt löfte: Jag finns här för dig. När det är svårt att veta vem man kan lita på är äkta närvaro allt.",
      getReading: "Boka konsultation",
    },
    footer: {
      getApp: "Skaffa appen för klarhet var du än är.",
      explore: "Utforska",
      special: "Specialiteter",
      more: "Mer",
      advisors: "Rådgivare",
      blog: "Vår blogg",
      applyCode: "Använd kampanjkod",
      support: "Kundsupport",
      about: "Om oss",
      apply: "Rådgivare? Ansök här",
      privacy: "Integritet",
      terms: "Villkor",
    },
    wallet: {
      title: "Köp samtalsminuter",
      intro:
        "Minuterna lagras i din Mystic-wallet och kan användas hos alla rådgivare (chatt / samtal / video).",
      numLabel: "Telefonnumret du ringer från",
      amount: "Välj belopp",
      buy: (amt) => `Köp ${money(amt)} kredit`,
      learn: "Läs mer om betalningssätt",
      err: "Ange ett giltigt telefonnummer",
      otp: (n) => `Kod skickad till ${n}. Ange den för att bekräfta.`,
      enterOtp: "Ange kod",
      verify: "Bekräfta & lägg till kredit",
      cancel: "Avbryt",
      success: (amt) => `${money(amt)} tillagt i din wallet!`,
      pm1: "Vipps MobilePay",
      pm2: "Kort (kräver registrering på ditt mobilnummer)",
      nolgin: "Ingen inloggning krävs för Vipps MobilePay – ring direkt.",
    },
  },

  header: {
    hello: "Hej",
    logout: "Logga ut",
    login: "Logga in",
  },

  footer: {
    categories: [
      "Dummy 1",
      "Dummy 2",
      "Dummy 3",
      "Dummy 4",
      "Dummy 5",
      "Dummy 6",
      "Dummy 7",
      "Dummy 8",
    ],
    paymentMethods: "Betalningssätt",
    footer: {
      getApp: "Skaffa appen för klarhet var du än är.",
      explore: "Utforska",
      special: "Specialiteter",
      more: "Mer",
      advisors: "Rådgivare",
      blog: "Vår blogg",
      applyCode: "Använd kampanjkod",
      support: "Kundsupport",
      about: "Om oss",
      apply: "Rådgivare? Ansök här",
      privacy: "Integritet",
      terms: "Villkor",
    },
  },
};

export default sv;
